module.exports = __webpack_public_path__ + "media/images/elements/Elemntas_10-6dc0782a024527685adf33e71954ea8f.svg";